import type { ZodError } from 'zod'

export class LaneError extends Error {
  override name = 'LaneError'
}

export class LaneNotFoundError extends LaneError {
  constructor(
    public readonly criteria: {
      id?: number
      customerId?: number
      originLocationId?: number
      destinationLocationId?: number
    }
  ) {
    super(`Lane not found: ${JSON.stringify(criteria)}`)
    this.name = 'LaneNotFoundError'
  }
}

export class LaneValidationError extends LaneError {
  constructor(public readonly zodError: ZodError) {
    super(`Lane validation failed: ${zodError.message}`)
    this.name = 'LaneValidationError'
  }
}

export class DuplicateLocationError extends LaneError {
  constructor(public readonly locationId: number) {
    super(`Origin and destination cannot be the same location (id=${locationId})`)
    this.name = 'DuplicateLocationError'
  }
}

export class LaneNotReadyError extends LaneError {
  constructor(
    public readonly laneId: number,
    public readonly status: string
  ) {
    super(`Lane ${laneId} is not ready (status=${status})`)
    this.name = 'LaneNotReadyError'
  }
}
